import React from 'react'
import { Navigate } from 'react-router-dom'

/**
 * Sale de `/login` sin pintar el formulario. Con sesión activa siempre va a
 * `/load` (replace): es el único bootstrap de edificios, destinos y Dexie.
 * `navigate(-1)` o `/` saltan ese paso y dejan la home vacía.
 */
function RedirectAwayFromLogin() {
  return <Navigate to="/load" replace />
}

/**
 * Inverso de `RequireAuth`: con sesión activa no monta el login, así que no se
 * puede disparar un segundo `sign_in`. Sin email, deja pasar (el logout llega
 * aquí recién después de `CLEAN_AUTH`).
 */
function GuestOnly({ children, profile }) {
  if (profile?.email) return <RedirectAwayFromLogin />
  return children
}

export default GuestOnly
